export default function ScoreGauge({ score, size = 220, label = "Revenue Score" }) {
  const clamped = Math.max(0, Math.min(100, score));
  let color = "#10B981";
  if (clamped < 50) color = "#EF4444";
  else if (clamped < 70) color = "#F59E0B";
  else if (clamped < 85) color = "#8B5CF6";

  const ring = size;
  const inner = size - 26;

  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: ring, height: ring }}
      data-testid="score-radial-chart"
    >
      <div
        className="rounded-full"
        style={{
          width: ring,
          height: ring,
          background: `conic-gradient(from -90deg, ${color} ${clamped}%, rgba(255,255,255,0.06) 0)`,
          filter: `drop-shadow(0 0 24px ${color}55)`,
        }}
      />
      <div
        className="absolute rounded-full flex flex-col items-center justify-center bg-[#0F1322] border border-slate-800"
        style={{ width: inner, height: inner }}
      >
        <div className="font-display text-5xl font-extrabold text-white leading-none">{clamped}</div>
        <div className="text-xs text-slate-500 mt-1">/ 100</div>
        <div className="text-[10px] font-semibold uppercase tracking-widest mt-3" style={{ color }}>
          {label}
        </div>
      </div>
    </div>
  );
}
